import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { owlClient } from '../../apiUtils/client';
import { QueryKey } from '../../types';
import { useClearClient } from './useClearClient';
import { useClientId } from './useClientId';

export const useFetchClient = () => {
  const params = useParams();
  const agentSlug = params?.agentSlug;
  const { readClientIdFromUrlOrStorage, saveClientIdToStorage } = useClientId();
  const clientId = readClientIdFromUrlOrStorage();

  const { clearClient } = useClearClient();
  return useQuery(
    [QueryKey.Client, clientId],
    async () => {
      const fetchedClient = await owlClient.client.fetch({
        args: { uuid: clientId! },
      });
      if (
        fetchedClient.data.agent.slug.toLowerCase() !==
        (agentSlug as string)?.toLowerCase()
      ) {
        throw new Error('Agent slug of client does not match agent in route');
      }

      saveClientIdToStorage(fetchedClient.data.uuid);
      return fetchedClient;
    },
    {
      enabled: !!clientId && !!agentSlug,
      onError: async () => {
        await clearClient();
      },
    },
  );
};
